import { useLayoutStore } from '~/providers/layout-store-provider';

import styles from './HeaderMobile.module.css';

export const HeaderMobile = () => {
  const mobileNavData = useLayoutStore((s) => s.navData.mobileHamburgerNav);
  console.log(mobileNavData);

  return (
    <header className={styles.headerContainer} data-testid="header-mobile-v2">
			<h1>Mobile Header V2</h1>
		</header>);

};